import { CASE_TYPE } from "@demandproai/shared";

const daysAgo = (days) => new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();

// A stand in case so the case list tour has a row to point at on an account
// that has not created anything yet. Built here and never fetched or saved:
// SampleCaseRow renders it inert, so none of its actions can be reached.
const SAMPLE_CASE = {
   _id: "sample-case",
   caseInfo: {
      caseName: "Sample: Doe v. Rivera Trucking",
      caseType: CASE_TYPE.AUTO_ACCIDENT,
      stateOfIncident: "Texas",
      dateOfIncident: daysAgo(150),
   },
   clients: [{ personalInfo: { clientName: "Jane Doe" } }],
   defendants: [{ personalInfo: { name: "Rivera Trucking LLC" } }],
   createdOn: daysAgo(21),
   updatedOn: daysAgo(2),
   // A finished demand, so the row shows the full set of actions rather than
   // the shorter draft set
   isDraftCase: false,
   processCount: 1,
   hasDownloadedDemand: true,
};

export default SAMPLE_CASE;
